import { AssignFarmModal } from './AssignFarmForm'
import { useState } from 'react'

type AssignFarmDialogProps = {
  resourceIds?: string[]
}

export const useAssignFarmDialog = () => {
  const [dialogState, setDialogState] = useState<AssignFarmDialogProps & { open: boolean }>({
    open: false,
  })

  return {
    openAssignFarmDialog: (props: AssignFarmDialogProps) =>
      setDialogState({ open: true, ...props }),
    assignFarmDialog: (
      <AssignFarmModal
        open={dialogState.open}
        onCancel={() => setDialogState({ open: false })}
        onSuccess={() => setDialogState({ open: false })}
        resourceIds={dialogState.resourceIds}
      />
    ),
  }
}

export type UseAssignFarmDialog = ReturnType<typeof useAssignFarmDialog>
